import React, {
  useContext,
  useRef,
  useEffect,
  useState,
  ChangeEvent,
} from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';

import { ResearchInterest } from './types';
import ResearchInterestSearchResults from './ResearchInterestSearchResults';
import _Container from "ResearchInterestTags-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=Container";
import _Border from "ResearchInterestTags-Border.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=Border";
import _RequiredText from "ResearchInterestTags-RequiredText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=RequiredText";
import _InputContainer from "ResearchInterestTags-InputContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=InputContainer";
import _SearchIcon from "ResearchInterestTags-SearchIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=SearchIcon";
import _Input from "ResearchInterestTags-Input.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=Input";
import _SelectedTagsContainer from "ResearchInterestTags-SelectedTagsContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=SelectedTagsContainer";
import _RemainingResearchInterests from "ResearchInterestTags-RemainingResearchInterests.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=RemainingResearchInterests";
import _SelectedResearchInterestContainer from "ResearchInterestTags-SelectedResearchInterestContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=SelectedResearchInterestContainer";
import _SelectedResearchInterestName from "ResearchInterestTags-SelectedResearchInterestName.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=SelectedResearchInterestName";
import _RemoveResearchInterestButton from "ResearchInterestTags-RemoveResearchInterestButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestTags.tsx?styleId=RemoveResearchInterestButton";


interface Props {
  query: string;
  onQueryInput(e: ChangeEvent<HTMLInputElement>): void;
  isLoading: boolean;
  selectedResearchInterests: Array<ResearchInterest>;
  searchResults: Array<ResearchInterest>;
  onAdd(ri: ResearchInterest): void;
  onRemove(ri: ResearchInterest): void;
  onCloseSearchResults(): void;
  maxResearchInterests: number;
  requiredText?: string;
  disabled?: boolean;
  hasError: boolean;
}

const NonFocusedColor = '#949494';
const FocusedColor = '#0954d3';
const RequiredTextHeight = '20px';

const defaultTheme: {
  border: React.CSSProperties;
  borderHighlighted: React.CSSProperties;
  inputContainer: React.CSSProperties;
  remainingResearchInterests: React.CSSProperties;
  remainingResearchInterestsHighlighted: React.CSSProperties;
} = {
  border: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: NonFocusedColor,
    borderRadius: '3px',
  },
  borderHighlighted: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: FocusedColor,
  },
  inputContainer: {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: NonFocusedColor,
  },
  remainingResearchInterests: {
    color: NonFocusedColor,
  },
  remainingResearchInterestsHighlighted: {
    color: FocusedColor,
  },
};

export const ThemeContext = React.createContext(defaultTheme);

const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const Border = /*#__PURE__*/styled("div", null, {
  displayName: "Border",
  styles: _Border
});

const RequiredText = /*#__PURE__*/styled("div", null, {
  displayName: "RequiredText",
  styles: _RequiredText
});

const InputContainer = /*#__PURE__*/styled("div", null, {
  displayName: "InputContainer",
  styles: _InputContainer
});

const SearchIcon = /*#__PURE__*/styled("img", null, {
  displayName: "SearchIcon",
  styles: _SearchIcon
});

const Input = /*#__PURE__*/styled("input", null, {
  displayName: "Input",
  styles: _Input
});

const SelectedTagsContainer = /*#__PURE__*/styled("div", null, {
  displayName: "SelectedTagsContainer",
  styles: _SelectedTagsContainer
});

const RemainingResearchInterests = /*#__PURE__*/styled("div", null, {
  displayName: "RemainingResearchInterests",
  styles: _RemainingResearchInterests
});

const SelectedResearchInterestContainer = /*#__PURE__*/styled("div", null, {
  displayName: "SelectedResearchInterestContainer",
  styles: _SelectedResearchInterestContainer
});

const SelectedResearchInterestName = /*#__PURE__*/styled("span", null, {
  displayName: "SelectedResearchInterestName",
  styles: _SelectedResearchInterestName
});

const RemoveResearchInterestButton = /*#__PURE__*/styled("button", null, {
  displayName: "RemoveResearchInterestButton",
  styles: _RemoveResearchInterestButton
});

export function ResearchInterestTags(props: Props) {
  const {
    selectedResearchInterests,
    query,
    onQueryInput,
    searchResults,
    onAdd,
    onRemove,
    isLoading,
    onCloseSearchResults,
    maxResearchInterests,
    requiredText,
    disabled = false,
    hasError,
  } = props;

  const boxWrapper = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  const theme = useContext(ThemeContext);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'contains' does not exist on type 'never'... Remove this comment to see the full error message
      if (!boxWrapper?.current?.contains(e.target)) {
        // Close the search results if the user clicks outside of the text input
        // or the search results box.
        onCloseSearchResults();
      }
    };

    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boxWrapper]);

  const selected = selectedResearchInterests.map((ri) => (
    <SelectedResearchInterestContainer key={ri.id}>
      <SelectedResearchInterestName title={ri.displayName}>
        {ri.displayName}&nbsp;&nbsp;
      </SelectedResearchInterestName>
      <RemoveResearchInterestButton
        onClick={() => onRemove(ri)}
        disabled={disabled}
      >
        <i className="fa fa-times" />
      </RemoveResearchInterestButton>
    </SelectedResearchInterestContainer>
  ));

  return (
    <Container>
      <Border
        hasError={hasError}
        style={isFocused ? theme.borderHighlighted : theme.border}
      >
        <div ref={boxWrapper}>
          <InputContainer style={theme.inputContainer}>
            <SearchIcon src={$image_url('upload_funnel/search-icon.svg')} />
            <Input
              type="text"
              disabled={
                disabled ||
                selectedResearchInterests.length >= maxResearchInterests
              }
              value={query}
              onChange={onQueryInput}
              placeholder="Add research interests"
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
            />
            {isLoading && <i className="fa fa-spinner fa-spin" />}
          </InputContainer>

          {searchResults.length > 0 && (
            <ResearchInterestSearchResults
              researchInterests={searchResults}
              onAdd={onAdd}
            />
          )}
        </div>

        <SelectedTagsContainer>{selected}</SelectedTagsContainer>

        <RemainingResearchInterests
          style={
            isFocused
              ? theme.remainingResearchInterestsHighlighted
              : theme.remainingResearchInterests
          }
        >
          {selectedResearchInterests.length} / {maxResearchInterests}
        </RemainingResearchInterests>
      </Border>

      {requiredText && <RequiredText>{requiredText}</RequiredText>}
    </Container>
  );
}
